// src/components/PaymentCallback.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import InactivityTimer from './InactivityTimer';

const PaymentCallback = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [status, setStatus] = useState(null);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);

        const paymentId = searchParams.get('payment_id');
        const orderId = searchParams.get('order_id');
        const signature = searchParams.get('signature');

        if (!paymentId || !orderId || !signature) {
            setStatus('failure');
            return;
        }

        // Send verification request to backend
        fetch(`http://localhost:8000/verify`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                razorpay_order_id: orderId,
                razorpay_payment_id: paymentId,
                razorpay_signature: signature
            })
        })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                setStatus('success');
            } else {
                setStatus('failure');
            }
        })
        .catch(err => {
            setStatus('failure');
        });

    }, [navigate, location]);

    if (status === 'success') {
        return (
            <div className="flex flex-col items-center justify-center h-screen bg-green-50">
                <h2 className="text-2xl text-green-600 font-bold">✅ Payment Successful!</h2>
                <p className="mt-2 text-gray-700">Your registration has been completed.</p>
                <button onClick={() => navigate('/')} className="mt-4 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700">
                    Go Home
                </button>
            </div>
        );
    }

    if (status === 'failure') {
        return (
            <div className="flex flex-col items-center justify-center h-screen bg-red-50">
                <h2 className="text-2xl text-red-600 font-bold">❌ Payment Failed</h2>
                <p className="mt-2 text-gray-700">Something went wrong with your payment.</p>
                <button onClick={() => navigate('/')} className="mt-4 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700">
                    Try Again
                </button>
            </div>
        );
    }

    return (
        <>
            <InactivityTimer />
            <div className="flex justify-center items-center h-screen">
                <p className="text-lg">Verifying payment...</p>
                <div className="w-6 h-6 border-4 border-blue-500 border-t-transparent rounded-full animate-spin ml-2"></div>
            </div>
        </>
    );
};

export default PaymentCallback;